import { User } from './../../Models/User';
import {
  LoadUserDetailAction, 
  LOAD_USER_DETAIL, 
  loadUserDetailSuccess, 
} from './actions';
import { put, takeLatest, all, call } from 'redux-saga/effects';
import { httpGet }  from '../../Http/HttpClient';
import { authService } from '../../index';
import { displayError } from '../../Helpers/Utilities';
import { history } from '../middleware';

/** User Details (from config table in db) */
function* loadUserDetailSaga(action: LoadUserDetailAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpGet,
      `${authService.appSettings.GetWebApiBaseUri()}/user/details`,
      token
    ); 
    const userDetail: User = yield call([response, response.json]);

    if(userDetail.user?.isActive === false) {
      history.push("/accountinactive")
    } else {
      yield put(loadUserDetailSuccess(userDetail));
    }
    
  } catch (error: any) {
    yield put(displayError(error));
  }  
}

export function* watchUserDetail() {
  yield takeLatest(LOAD_USER_DETAIL, loadUserDetailSaga);
}
/** End User Details */



export default function* sharedSagas() {
  yield all([
    watchUserDetail(),
  ]);
}